import React from 'react';
import Skeleton from '../Skeleton/Skeleton';
import styles from './TableSkeleton.module.css';

const TableSkeleton = ({ rowCount = 5, columnCount = 3 }) => (
  <div className={styles.tableSkeletonContainer}>
    <div className={styles.tableSkeletonHeader}>
      <Skeleton width="200px" height="30px" />
      <Skeleton width="200px" height="30px" />
      <Skeleton width="30px" height="30px" borderRadius="50%" />
    </div>
    <div className={styles.tableSkeletonTable}>
      <div className={styles.tableSkeletonThead}>
        <div className={styles.tableSkeletonTr}>
          {Array.from({ length: columnCount }).map((_, index) => (
            <div key={index} className={styles.tableSkeletonTh}>
              <Skeleton width="100%" height="20px" />
            </div>
          ))}
        </div>
      </div>
      <div className={styles.tableSkeletonTbody}>
        {Array.from({ length: rowCount }).map((_, rowIndex) => (
          <div key={rowIndex} className={styles.tableSkeletonTr}>
            {Array.from({ length: columnCount }).map((_, colIndex) => (
              <div key={colIndex} className={styles.tableSkeletonTd}>
                <Skeleton width="100%" height="14px" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default TableSkeleton;
